import React from 'react';
import ReactDOM from 'react-dom';
import './Loader.css';

const Loader = () => {
  return ReactDOM.createPortal(
    <div className='wrapper'>
      <div className='loader'></div>
    </div>,
    document.getElementById("loader")
  );
};

export const SpinnerImg = () => {
  return (
    <div className='--center-all'>
      <div className='loader'></div>
    </div>
  );
};

export default Loader;